module.exports = __webpack_public_path__ + "static/sharper-shop-a1269fd8d274fdb211b0cbc641822228.png";